import React from 'react'
import { HowItWorksStep } from '../data/howItWorks'

interface HowItWorksCopyPanelProps {
  step: HowItWorksStep
  isActive: boolean
}

const HowItWorksCopyPanel: React.FC<HowItWorksCopyPanelProps> = ({ step, isActive }) => (
  <div className="v2-hiw-panel v2-hiw-copy-panel" aria-hidden={!isActive} data-active={isActive}>
    <div className="v2-hiw-copy-panel__eyebrow">
      <b>{step.number}</b>
      <span>{step.kicker}</span>
    </div>
    <h3>{step.title}</h3>
    <p>{step.description}</p>
  </div>
)

export default HowItWorksCopyPanel
